import { PropTypes } from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { uploadKTP } from "../../actions/authActions";
import icon_plus from "../../img/icon_plus.svg";
import uuid from "../../validation/uuid";

import SpinnerSimpleBlue from "../common/SpinnerSimpleBlue";

class UploadPicture extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.fileInput = React.createRef();
  }
  handleSubmit(e) {
    e.preventDefault();
    const file = this.fileInput.current.files[0];
    const date_now = moment(Date.now()).format("X");
    const objParams = {
      file: file,
      file_name: "ktp_" + date_now + "_" + uuid(),
      dirName: "foto_ktp",
    };
    let finalObject;
    finalObject = {
      objParams,
    };
    this.props.uploadKTP(finalObject);
  }
  render() {
    let itemContent;
    const { itemLoading, loadingProcess } = this.props.auth;
    if (loadingProcess && itemLoading === "ktp") {
      itemContent = (
        <div className="upload_container vertical_center">
          <div
            className="vertical_horizontal_center_child"
            style={{ fontSize: "20px" }}
          >
            <SpinnerSimpleBlue
              width={40}
              unik="loading_item_list"
              marginTop="0px"
              center={true}
              border={0.1}
            />
          </div>
        </div>
      );
    } else {
      itemContent = (
        <label
          className="fileContainer upload_container vertical_center"
          style={{
            backgroundImage: `url(${icon_plus})`,
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
          }}
        >
          <div
            className="vertical_horizontal_center_child"
            style={{ cursor: "pointer", fontSize: "20px", width: "100%" }}
          >
            <input
              style={{ cursor: "pointer" }}
              type="file"
              accept="image/*"
              ref={this.fileInput}
              onChange={this.handleSubmit}
            />
          </div>
        </label>
      );
    }

    return <div>{itemContent}</div>;
  }
}
UploadPicture.propTypes = {
  auth: PropTypes.object.isRequired,
  uploadKTP: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
  auth: state.auth,
});
export default connect(mapStateToProps, {
  uploadKTP,
})(UploadPicture);
